import Http from '../request-method.js';
import Crypto from '../../utils/utils-crypto.js';

export default {
    //登录，用户登录
    userLogin(acc, pwd) {
        return Http.post('/AdminApi/Login', {
            LoginName: acc,
            LoginPwd: pwd
        });
    },

    userLoginV2(data) {
        return Http.post('/AdminApi/LoginV2',data);
    },

    contestantRegister(acc, pwd){
        return Http.post('/AdminApi/ContestantRegister', {
            LoginName: acc,
            LoginPwd: pwd
        });
    },

    contestantRegisterV2(data) {
        return Http.post('/AdminApi/ContestantRegisterV2',data);
    },

    //获取用户信息
    getUserInfo() {
        return Http.get('AdminApi/AccountInfo', {});
    },


     //获取用户信息
    selectAccountList(data) {
        return Http.post('AdminApi/SelectAccountList', data);
    },

    selectUnitAccountList(data) {
        return Http.post('AdminApi/SelectUnitAccountList', data);
    },

    setUnitIsSuper(data){
        return Http.get('AdminApi/SetUnitIsSuper', data);
    },

    //修改密码
    editPassword(oPwd, nPwd) {
        return Http.post('AdminApi/UpdatePwd', {
            OldPwd: oPwd,
            NewPwd: nPwd
        });
    },

    editPasswordV2(data) {
        return Http.post('AdminApi/UpdatePwdV2', data);
    },
   
    //重置用户密码
    resetUserPassword(name) {
        return Http.post('UserInfo/ResetPwd', {
            user: name
        });
    },

    editAccount(data){
        return Http.post('AdminApi/EditAccount', data);
    },
    lockOrUnlock(data){
        return Http.get('AdminApi/LockOrUnlock', data);
    },
    
    resetPassword(data){
        return Http.post('AdminApi/ResetPassword', data);
    },

    sendMobileCode(data){
        return Http.get('AdminApi/SendMobileCode', data);
    },
    sendMobileCodeByAccId(data){
        return Http.get('AdminApi/SendMobileCodeByAccId', data);
    },
    checkPhoneCode(data){
        return Http.get('AdminApi/CheckPhoneCode', data);
    },
    bindAccPhone(data) {
        return Http.get('AdminApi/BindAccPhone', data);
    },
    getPermissionTree() {
        return Http.get('AdminApi/GetPermissionTree');
    },
    setAccountPermission(data) {
        return Http.post('AdminApi/SetAccountPermission', data);
    },
    getMenuListByAccountPermission() {
        return Http.get('AdminApi/GetMenuListByAccountPermission');
    },
    verifyPermission(data){
        return Http.get('AdminApi/VerifyPermission', data);
    }

  
}